import React from 'react'

const Overlay = props => {
  return <div className={props.classes} onClick={props.handleClick} />
}

export default Overlay
